import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Tooltip } from "@mui/material";
import ConfigData from "../config/config.json";
import { GlobalMessageContext } from "../app/App";

const webserver = ConfigData.WEBSERVER;
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function ExaminerSelector(props) {
  const { setGlobalMessage } = React.useContext(GlobalMessageContext);

  const [allExaminers, setAllExaminers] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    // On autofill we get a stringified value.
    const returnValue = typeof value === "string" ? value.split(",") : value;

    if (props.index === undefined) {
      props.setSelectedExaminers(returnValue);
    } else {
      fetch(
        webserver.protocol +
          "://" +
          webserver.host +
          ":" +
          webserver.port +
          "/examProcess/setExaminers/" +
          props.id,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(returnValue),
        }
      )
        .then((response) => {
          if (response.status !== 200) {
            throw new Error(
              "Unable to access endpoint: examProcess/setExaminers"
            );
          }
          return response;
        })
        .then((response) => response.json())
        .then((data) => {
          props.setSelectedExaminers((prev) => {
            let temp = JSON.parse(JSON.stringify(prev));
            temp[props.index].examiners = returnValue;
            return temp;
          });
          setGlobalMessage({
            globalMessage: "Änderung erfolgreich",
            severity: "success",
          });
        })
        .catch((error) => {
          setGlobalMessage({
            globalMessage: "Vorgang fehlgeschlagen",
            severity: "error",
          });
        });
    }
  };

  React.useEffect(() => {
    fetch(
      webserver.protocol +
        "://" +
        webserver.host +
        ":" +
        webserver.port +
        "/examProcess/getAllExaminers",
      { method: "GET", credentials: "include" }
    )
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Error: " + response.status);
        }
        return response;
      })
      .then((response) => response.json())
      .then((data) => {
        setAllExaminers(data);
      })
      .catch((error) => {});
  }, []);

  return (
    <div>
      <FormControl sx={{ width: props.width }} size="small">
        <InputLabel id="demo-multiple-checkbox-label">Prüfer</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={props.selectedExaminers}
          onChange={(e) => handleChange(e)}
          input={<OutlinedInput label="Prüfer" />}
          renderValue={(selected) => selected.join(", ")}
          MenuProps={MenuProps}
        >
          {props.selectedExaminers.map((examiner) => (
            <MenuItem key={examiner} value={examiner}>
              <Checkbox
                checked={props.selectedExaminers.indexOf(examiner) > -1}
              />
              <Tooltip title={examiner} enterDelay={1000}>
                <ListItemText primary={examiner} />
              </Tooltip>
            </MenuItem>
          ))}

          {allExaminers.map((examiner) =>
            props.selectedExaminers.indexOf(examiner) <= -1 ? (
              <MenuItem key={examiner} value={examiner}>
                <Checkbox checked={false} />
                <Tooltip title={examiner} enterDelay={1000}>
                  <ListItemText primary={examiner} />
                </Tooltip>
              </MenuItem>
            ) : null
          )}
        </Select>
      </FormControl>
    </div>
  );
}
